import React from 'react';
import './App.css'; 
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import './Components/PDFViewer.css'; 
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Login } from './Pages/Login';
import { OnboardingStart } from './Pages/Onboarding';
import HttpRequestProvider from './Blocks/HttpRequestProvider';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { UserProvider } from './Blocks/UserProvider';
import { ThemeProvider } from '@mui/material/styles';
import FormPage from './Pages/Standalone/Forms/FormPage';
import theme from './Theme';
import CreateAppointment from './Pages/AppointmentScheduling/CreateAppointment';
import AdminDashboard from './Pages/Admin/AdminDashboard';
import AdminRoute from './Blocks/Admin/AdminRoute';
import EmailingPage from './Pages/Admin/EmailingPage';
import AdminUsersPage from './Pages/Admin/AdminUsersPage';
import CreateUserForm from './Pages/Admin/CreateUserForm';
import AdminLayout from './Layouts/AdminLayout';
import GanttChart from './Blocks/GanttChart';
import BillingProfilePage from './Pages/Invoicing/ProfilDeFacturation';
import InvoiceTemplateEditor from './Pages/Invoicing/InvoiceTemplateEditor';
import InvoiceForm from './Pages/Invoicing/Facture';
import ClientManagement from './Pages/Invoicing/ClientManagement';
import FactureListPage from './Pages/Invoicing/FactureList';
import AccountingDashboard from './Pages/Accounting/AccountingDashboard';
import UploadTransactions from './Pages/Accounting/UploadTransactions';
import UploadDocuments from './Pages/Accounting/UploadDocuments';
import AIAgentApp from './Pages/AIAgent/AIAgentApp';
import { detectAIAgentRoute } from './utils/routingUtils';

// Component for protected routes that require authentication
const ProtectedApp = () => {
  return (
    <UserProvider>
      <Routes>
        {/* App pages*/}
        <Route path="/" element={<FactureListPage/>} />
        <Route path="/onboarding" element={<OnboardingStart />} />
        <Route path="/login" element={<Login />} />

        {/* Invoice routes */}
        <Route path="/invoicing" element={<FactureListPage />} />
        <Route path="/invoicing/factures" element={<FactureListPage />} />
        <Route path="/invoicing/invoice" element={<InvoiceForm documentType="facture" />} />
        <Route path="/invoicing/facture" element={<InvoiceForm documentType="facture" />} />
        <Route path="/invoicing/facture/:id" element={<InvoiceForm documentType="facture" />} />
        
        {/* Receipt routes */}
        <Route path="/invoicing/receipt" element={<InvoiceForm documentType="recu" />} />
        <Route path="/invoicing/recu" element={<InvoiceForm documentType="recu" />} />
        <Route path="/invoicing/recu/:id" element={<InvoiceForm documentType="recu" />} />
        
        <Route path="/invoicing/customers" element={<ClientManagement />} />

        <Route path="/invoicing/template" element={<InvoiceTemplateEditor />} />
        <Route path="/invoicing/billing-profile" element={<BillingProfilePage />} />

        {/* Accounting routes */}
        <Route path="/accounting" element={<AccountingDashboard />} />
        <Route path="/accounting/dashboard" element={<AccountingDashboard />} />
        <Route path="/accounting/upload-transactions" element={<UploadTransactions />} />
        <Route path="/accounting/upload-documents" element={<UploadDocuments />} />

        <Route path="/appointments/create" element={<CreateAppointment />} />
        <Route path="/ganttchart" element={<GanttChart/>} />
        <Route path="/admin" element={<AdminLayout />}>
            <Route path="dashboard" element={<AdminRoute element={<AdminDashboard />} />} />
            <Route path="emailing" element={<AdminRoute element={<EmailingPage />} />} />
            <Route path="users" element={<AdminRoute element={<AdminUsersPage />} />} />
            <Route path="users/create"  element={<AdminRoute element={<CreateUserForm />} />} />
        </Route>
      </Routes>
    </UserProvider>
  );
};

function App() {
  // Check if this is an AI agent subdomain
  const { isSubdomain } = detectAIAgentRoute();

  // If it's an AI agent subdomain, render only the AI agent app
  if (isSubdomain) {
    return (
      <HttpRequestProvider>
        <ThemeProvider theme={theme}>
          <ToastContainer />
          <Router> 
            <AIAgentApp />
          </Router>
        </ThemeProvider>
      </HttpRequestProvider>
    );
  }

  // Otherwise, render the main app with separated public and protected routes
  return (
    <HttpRequestProvider>
      <ThemeProvider theme={theme}>
        <ToastContainer />
        <Router> 
          <Routes>
            {/* Public routes that don't require authentication */}
            <Route path="/form" element={<FormPage />} />
            <Route path="/ai-agent/*" element={<AIAgentApp />} />
            
            {/* All other routes require authentication */}
            <Route path="/*" element={<ProtectedApp />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </HttpRequestProvider>
  );
}

export default App;
